"use client";

import { memo } from "react";
import type { RiskData, Contributor } from "@/types/endpoints/reports/GetAiReportById";
import ContributorsList from "../primitives/ContributorsList";

export type RiskReportVariant = 'default' | 'compact' | 'with-title';

interface RiskReportContentProps {
  risk: RiskData;
  contributors: Contributor[];
  getActionTypeName: (type: string) => string;
  variant?: RiskReportVariant;
  title?: string;
}

export const RiskReportContent = memo(function RiskReportContent({
  risk,
  contributors,
  getActionTypeName,
  variant = 'default',
  title,
}: RiskReportContentProps) {
  if (variant === 'with-title') {
    return (
      <div className="flex flex-col gap-4 min-h-0 h-full">
        {title && (
          <h3 className="text-sm font-semibold text-[#1A1A1A]">{title}</h3>
        )}
        <ContributorsList
          contributors={contributors}
          riskLevel={risk.level}
          getActionTypeName={getActionTypeName}
        />
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="flex-1 flex min-h-0 overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          <ContributorsList
            contributors={contributors}
            riskLevel={risk.level}
            getActionTypeName={getActionTypeName}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1">
      <ContributorsList
        contributors={contributors}
        riskLevel={risk.level}
        getActionTypeName={getActionTypeName}
      />
    </div>
  );
});

export default RiskReportContent;
